

























































































import Vue from 'vue';
import Component from 'vue-class-component';
import { layout, loader, user, tickets } from '@/modules/shared/shared/store/namespaces';
import {
    FETCH_TAPE_DELIVERIES,
    FETCH_TAPE_DELIVERY_BY_ID,
    SET_TAPE_CHANGE_TICKET,
} from '@/modules/tickets/shared/store/tickets.actions';
import {
    GET_TAPE_DELIVERIES,
    GET_TAPE_DELIVERIES_OPTIONS,
    GET_TAPE_DELIVERY,
} from '@/modules/tickets/shared/store/tickets.getters';
import { Watch } from 'vue-property-decorator';

import moment from 'moment';
import { TicketsDatatableItem } from '@/modules/tickets/shared/domain/tickets-datatable-item';
import { TapeChangeType } from '@/modules/shared/shared/domain/constants/constants';
import { GET_CUSTOMER_ID, IS_EMPLOYEE, UserGetters } from '@/modules/users/store/user.getters';
import { LayoutMutations } from '@/modules/shared/layouts/store/layout.mutations';
import { EventBus } from '@/main';
import { EventBusMessages } from '@/modules/shared/shared/domain/constants/event-bus-messages';
import TapeChangeDetail from './TapeChangeDetail.vue';

@Component({
    name: 'tape-changes',
})
export default class TapeChanges extends Vue {
    @user.Getter(IS_EMPLOYEE) IS_EMPLOYEE;

    searchTapeDeliveries: string = '';
    limitTapeDeliveries: number = 20;
    pageTapeDeliveries: number = 1;
    itemsPerPageTapeDeliveries: number[] = [5, 10, 15, 20];
    isFetchingTapeDeliveries: boolean = false;
    isFetchingTapeDelivery: boolean = false;
    tapeDeliveriesOptions: any = {};
    givenTapes: string = '';
    takenTapes: string = '';

    get headersTapeDeliveries() {
        return [
            { text: 'Ticket', value: 'ticketId', align: 'start', sortable: false, show: true },
            {
                text: 'Cliente',
                value: 'customer',
                align: 'start',
                sortable: false,
                show: this.IS_EMPLOYEE,
            },
            {
                text: 'Nombre del Contacto Solicitante',
                value: 'contactFullName',
                align: 'start',
                sortable: false,
                show: true,
            },
            {
                text: 'Cédula de Identidad del Contacto Solicitante',
                value: 'contactCi',
                align: 'start',
                sortable: false,
                show: true,
            },
            { text: 'Fecha', value: 'date', align: 'start', sortable: false, show: true },
        ];
    }

    showTapeDeliverySheet() {
        const requirementTicket = {
            generalInformation: {
                contactId: this.tapeDelivery.id,
                firstName: this.tapeDelivery.contact.name,
                lastName: this.tapeDelivery.contact.lastName,
                idNumber: this.tapeDelivery.contact.ci,
                ticketId: this.tapeDelivery.ticketId,
                customerName: this.tapeDelivery.customer.name,
                date: moment(this.tapeDelivery.date).format('DD/MM/YYYY'),
                hour: moment(this.tapeDelivery.date).format('hh:mm A'),
            },
            tapes: this.getTapes(this.tapeDelivery.tapeChanges),
        };

        localStorage.setItem('requirementTicket', JSON.stringify(requirementTicket));
        let to = { name: 'tape-delivery-reception' };
        let routeData = this.$router.resolve(to);
        window.open(routeData.href + '?localStorage=false', '_blank');
    }

    tapeChanges() {
        this.takenTapes = this.tapeDelivery.tapeChanges
            .filter(tapeChange => tapeChange.tapeDeliveryChangeType.id === TapeChangeType.TAKE.id)
            .map(tapeChange => tapeChange.tapeCode)
            .join(', ');

        if (!(this.takenTapes.length > 0)) {
            this.takenTapes = 'N/A';
        }

        this.givenTapes = this.tapeDelivery.tapeChanges
            .filter(tapeChange => tapeChange.tapeDeliveryChangeType.id === TapeChangeType.GIVE.id)
            .map(tapeChange => tapeChange.tapeCode)
            .join(', ');

        if (!(this.givenTapes.length > 0)) {
            this.givenTapes = 'N/A';
        }
    }

    async showTapeChangeDetails(item) {
        this.givenTapes = '';
        this.takenTapes = '';
        this.isFetchingTapeDelivery = true;
        const fetched: boolean = await this.fetchTapeDeliveryById(item.item.id);

        if (fetched) {
            this.tapeChanges();
            this.isFetchingTapeDelivery = false;
        }
    }

    @Watch('searchTapeDeliveries')
    async applyKeywordFilter(value) {
        if (value !== '') {
            await this.changeTapeDeliveries();
        }
    }

    @Watch('tapeDeliveriesOptions.itemsPerPage')
    onItemsPerPageChangedOnIncidents(value) {
        this.limitTapeDeliveries = value;
        this.changeTapeDeliveries();
    }

    getTapes(tapeChanges) {
        return tapeChanges.map(tapeChange => ({
            code: tapeChange.tapeCode,
            giveOrTake:
                tapeChange.tapeDeliveryChangeType.id === TapeChangeType.GIVE.id
                    ? TapeChangeType.GIVE.name
                    : TapeChangeType.TAKE.name,
        }));
    }

    async changeTapeDeliveries() {
        this.isFetchingTapeDeliveries = true;
        await this.fetchTapeDeliveries({
            customerId: this.IS_EMPLOYEE ? undefined : this.customerId,
            limit: this.limitTapeDeliveries,
            start: this.pageTapeDeliveries,
            keyword: this.searchTapeDeliveries,
        });
        this.isFetchingTapeDeliveries = false;
    }

    async mounted() {
        this.changeTitle({ title: 'Gestión de Cintas', route: ['TICKETS'] });
        EventBus.$emit(EventBusMessages.SHOW_LOADER);
        await this.fetchTapeDeliveries({
            customerId: this.IS_EMPLOYEE ? undefined : this.customerId,
            limit: this.limitTapeDeliveries,
            start: this.pageTapeDeliveries,
            keyword: this.searchTapeDeliveries,
        });
        EventBus.$emit(EventBusMessages.HIDE_LOADER);
    }

    @user.Getter(GET_CUSTOMER_ID) customerId;

    @tickets.Getter(GET_TAPE_DELIVERIES) tapeDeliveries!: TicketsDatatableItem[];

    @tickets.Getter(GET_TAPE_DELIVERIES_OPTIONS) tapeDeliveriesListOptions;

    @tickets.Getter(GET_TAPE_DELIVERY) tapeDelivery;

    @tickets.Action(FETCH_TAPE_DELIVERIES) fetchTapeDeliveries!: (options: {
        customerId?: number;
        limit: number;
        start: number;
        keyword?: string;
    }) => Promise<boolean>;

    @tickets.Action(FETCH_TAPE_DELIVERY_BY_ID) fetchTapeDeliveryById!: (
        id: number,
    ) => Promise<boolean>;

    @tickets.Action(SET_TAPE_CHANGE_TICKET) setTapeChangeTicket!: (item: any) => Promise<void>;

    @layout.Mutation(LayoutMutations.CHANGE_TITLE) changeTitle!: (title: {
        title: string;
        route: string[];
    }) => void;
}
